import {useEffect, useState} from "react";
import React from "react";
import axios from "axios";
// import Select from "react-select";
import "./style.css";
import {url} from "./BaseUrl"; // Import your CSS file
const tele = window.Telegram.WebApp;
tele.expand();
function User(){
    const [isLoading, setIsLoading] = useState(false); // State for loading indicator
    const [users, setUsers] = useState([]);
    const user = tele.initDataUnsafe?.user?.username;
    // const user_id = tele.initDataUnsafe?.user?.id;

    //console.log(admins)
    async function getAdmins() {
        setIsLoading(true);
        try {
            await axios.get(url+'/users', {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
            // await axios.get('https://testmyweb.pagekite.me/api/users', {headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}})
                .then((res) => {
                    setUsers(res.data);
                })
        }catch (error) {
            console.log(error);
        }finally {
            setIsLoading(false);
        }

    }useEffect(() => {
        getAdmins();
    }, []);

    const [searchText,setSearchText] = useState("");



    const [editingUserIndex, setEditingUserIndex] = useState(null);
    const [editedUserData, setEditedUserData] = useState({}); // State for edited user data
    const handlesearchChange = (event) => {
        setSearchText(event.target.value);
        console.log('New search text:', searchText);
        const filteredUsers = users.filter(admin =>  {
            const userName = admin.user_name?.toLowerCase() || '';
            const chatId = admin.chat_id?.toString()?.toLowerCase() || '';
            const firstName = admin.first_name || '';
            const lastName = admin.last_name || '';

            // Assuming you've handled Arabic character encoding and normalization
            return userName.includes(searchText.toLowerCase()) ||
                chatId.includes(searchText.toLowerCase()) ||
                firstName.includes(searchText) ||
                lastName.includes(searchText);
        });
        const matchingUserIndex = filteredUsers.findIndex(user => user.chat_id === (editingUserIndex !== null ? users[editingUserIndex].chat_id : null)); // Check for existing editing user
        setEditingUserIndex(matchingUserIndex !== -1 ? matchingUserIndex : null); // Update editing index if found
        setUsers(filteredUsers);
    }
    const handleEditClick = (index) => {
        setEditingUserIndex(index);
        console.log(editingUserIndex)
        setEditedUserData({ // Pre-fill with existing data
            ...users[index],
        });
    };

    const handleSave = async (chat_id) => {
        try {
            const updatedUser = {
                ...users[chat_id], // Copy the original user object
                id_user: editedUserData.id_user,
                chat_id: editedUserData.chat_id,
                username: editedUserData.username,
                first_name: editedUserData.first_name,
                last_name: editedUserData.last_name,
                count: editedUserData.count
            };
            await axios.put(url+`/update/${chat_id}`, updatedUser,{headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'Access-Control-Allow-Origin': '*'}});
            const updatedUsers = [...users];
            const indexToUpdate = updatedUsers.findIndex(user => user.chat_id === chat_id);

            if (indexToUpdate !== -1) {
                updatedUsers[indexToUpdate] = {
                    ...updatedUsers[indexToUpdate],
                    chat_id: editedUserData.chat_id,
                    count: editedUserData.count
                };
            }
            setUsers(updatedUsers);
            setEditingUserIndex(null); // Stop editing
        } catch (error) {
            console.error(error);
        }
    };
    const handleSetAdmin = async (chat_id) => {
        // console.log(index)
        try {
            await axios.post('https://testmyweb.pagekite.me/api/store/', {chat_id})
                .then((res => {
                    if(res.data ==="exist")
                        alert("تم تعيين أدمن بالفعل")
                    else
                        alert("تم تعيين أدمن بنجاح")
                }));
        } catch (error) {
            console.error(error);
        }
    };

    return(
        <>
            <div className="content-center flex flex-row justify-between w-auto mt-2 h-auto">
                <div className="bg-gradient-to-b from-sky-500 to-indigo-500 shadow-xl shadow-indigo-500/40 rounded-b mx-auto w-full">
                    <div className="p-2 md:px-10 flex content-center justify-between  m-4" dir="rtl">
                        <h1 className="text-lg font-bold text-gray-900 text-right">
                            مرحباَ بك يا <span className="text-lg font-bold text-gray-900 text-right mr-2">{user}</span>
                        </h1>
                    </div>
                    <div className="p-2 md:px-8 flex justify-start  m-4" dir={"rtl"}>
                        <input type="text" className="border-solid border-2 rounded-md w-1/3 max-sm:w-2/3 px-2 py-1"
                               placeholder="بحث عن اسم المستخدم"
                               // onChange={(e) => handleSearch(e.target.value)}
                               onChange={handlesearchChange}
                               value={searchText}
                        />
                    </div>
                    <div className="p-2 md:px-8 justify-center m-4 mb-6 bg-white rounded-xl">
                        {isLoading ? (
                            <div className="flex items-center justify-center"> {/* Center the content horizontally */}
                                <img className="w-12 h-12 animate-spin mr-4" src="https://www.svgrepo.com/show/199956/loading-loader.svg" alt="Loading icon" /> {/* Add margin for spacing */}
                                <span className="text-xl font-bold">جاري التحميل...</span>
                            </div>
                        ):(
<>

                            <div className={'flex justify-evenly w-full'} dir={'rtl'}>
                                <div className={"text-center py-2 pr-2 w-14 max-w-16"}>#</div>
                                <dir className={"text-center py-2 pr-2 w-32 max-w-36"}>اسم المستخدم</dir>
                                <dir className={"text-center py-2 pr-2 w-32 max-w-36 max-lg:hidden"}>اسم</dir>
                                <dir className={"text-center py-2 pr-2 w-32 max-w-36 max-sm:hidden"}>رقم القيد</dir>
                                <dir className={"text-center py-2 pr-2 w-32 max-w-36 max-sm:w-12"}>عداد</dir>
                                <dir className={"text-center py-2 pr-2 w-20 max-w-24"}>فعل</dir>
                            </div>
                            <div dir={'rtl'} className={'h-72 max-h-96 overflow-y-scroll scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100'}>
                        {(users.filter(admin =>  {
                            const userName = admin.user_name?.toLowerCase() || '';
                            const chatId = admin.chat_id?.toString()?.toLowerCase() || '';
                            const firstName = admin.first_name || '';
                            const lastName = admin.last_name || '';

                            // Assuming you've handled Arabic character encoding and normalization
                            return userName.includes(searchText.toLowerCase()) ||
                                chatId.includes(searchText.toLowerCase()) ||
                                firstName.includes(searchText) ||
                                lastName.includes(searchText);
                        })
                                    .map((admin,index)=>(
                            <div key={index} className={"border-b text-center hover:bg-orange-100 flex justify-evenly p-2 w-full"}>
                                <div className={"w-14 max-w-16 select-none"}>
                                    <div>{index+1}</div>
                                </div>
                                <div className={"py5 w-32 max-w-36 max-sm:w-40"}>
                                    {/*<img src={"https://cdn-icons-png.flaticon.com/512/149/149071.png"} alt={"user"} className={"w-10 h-10"}/>*/}
                                    <div className={"font-medium"} dir={'ltr'}>@{admin.user_name??' '}
                                        <dl className={"text-gray-400"}>
                                            <dt className={'sr-only'}>اسم</dt>
                                            <dd className={'lg:hidden'}> {admin.first_name} {admin.last_name}</dd>
                                            <dt className={'sr-only'}>رقم القيد</dt>
                                            <dd className={'sm:hidden'}>
                                                {editingUserIndex === index ? (
                                                    <input type="text" className={'w-full text-black'} value={editedUserData.id_user || admin.id_user}
                                                           onChange={(e) =>
                                                               setEditedUserData({ ...editedUserData, id_user: e.target.value,})}/>
                                                ):(<>{admin.id_user}</>)}
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                                <div  className={'w-32 max-w-36 max-lg:hidden'}>
                                    <div className={"font-medium"}>{admin.first_name}</div>
                                    <div className={"text-gray-400"}>{admin.last_name}</div>
                                </div>
                                <div className={'w-32 max-w-36 max-sm:hidden'}>
                                    {editingUserIndex === index ? (
                                        <input type="text" className={'w-full text-black'} value={editedUserData.id_user || admin.id_user}
                                               onChange={(e) =>
                                                   setEditedUserData({ ...editedUserData, id_user: e.target.value,})}/>
                                    ):(<div className={""}>{admin.id_user}</div>)}
                                </div>
                                <div  className={'w-32 max-w-36 max-sm:w-12 select-none'}>
                                    {editingUserIndex === index ? (
                                        <input type="text" className={'w-full'} name='count' value={editedUserData.count }
                                               onChange={(e) =>
                                                   setEditedUserData({ ...editedUserData, count: e.target.value,})}/>
                                    ):(<div className={"font-medium "}>{admin.count}</div>)}
                                </div>
                                <div  className={'w-20 max-w-24'}>
                                    {editingUserIndex !== index ? (
                                        <>
                                            <button className="bg-blue-500 hover:bg-blue-700 text-white rounded p-2"
                                                    onClick={() => handleEditClick(index)}>
                                                تعديل
                                            </button>
                                            <button className={"bg-green-500 hover:bg-green-700 text-white rounded p-2"}
                                                    onClick={() => handleSetAdmin(admin.chat_id)}
                                            >تعيين</button>
                                        </>
                                    ):(
                                        <>
                                            <button className="bg-green-500 hover:bg-green-700 text-white rounded p-2"
                                                    onClick={() => handleSave(admin.chat_id)}>
                                                حفظ
                                            </button>
                                            <button  className="bg-red-500 hover:bg-red-700 text-white rounded p-2"
                                                     onClick={() => setEditingUserIndex(null)}>
                                                إلغاء
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        )))}
                    </div>
</>
                    )}
                    </div>
                </div>
            </div>
        </>
    );

}

export default User